(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-sq-footer]').forEach(footer => {
      if (footer.dataset.initialized) return;
      footer.dataset.initialized = 'true';
      const columns = footer.querySelectorAll('.sq-footer__column');
      const desktop = window.matchMedia('(min-width: 750px)');
      const update = () => columns.forEach(column => {
        column.open = desktop.matches;
        column.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
      });
      update();
      desktop.addEventListener('change', update);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(footer)) desktop.removeEventListener('change', update);
      }, {once: true});
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
